import { FETCH_ADS } from "./constants";
import { SUCCESS, FAILURE, PENDING } from "../constants";

import { fetchAdsService } from "../../services/dcm/ads";
import { setAuthError } from "../app/global";

const beginFetchAds = (campaignId) => ({
  type: FETCH_ADS,
  status: PENDING,
  campaignId
});

const successAds = placements => ({
  type: FETCH_ADS,
  status: SUCCESS,
  data: placements
});

const failureAds = err => ({
  type: FETCH_ADS,
  status: FAILURE,
  err
});

export const fetchAds = (campaignId) => {
  return async dispatch => {
    dispatch(beginFetchAds());

    let ads;

    try {
      ads = await fetchAdsService(campaignId);

      dispatch(successAds(ads));
    } catch (e) {
      if (e.message === "UNAUTHORIZED") {
        dispatch(setAuthError());
        return;
      }

      dispatch(failureAds(e));
    }
  };
};
